<template>

    <div class="last-part-form" v-on:click="hide($event)" id="last-part-form" v-if="dataStore.showLastPartForm">

        <form v-on:submit.prevent="submitForm($event)">

            <p v-if="errors.length">
                <ul>
                    <li v-for="(error,index) in errors" :key="index">{{ error }}</li>
                </ul>
            </p>

            <button title="close and send" id="close-last-part-form" class="close-popup" @click="toggleForm"><i class="fas fa-times"></i></button>

            <legend>{{ language.submit_legend }}</legend>

            <div class="row input-row">

                <div class="input-fields">

                    <div v-if="hideinputs.hide_name" class="input-wrapper">
                        <div class="form-group">
                            <input type="text" v-model="formData.name" class="form-control" id="name" :placeholder="language.name">
                        </div>
                    </div>

                    <div v-if="hideinputs.hide_address" class="input-wrapper">
                        <div  class="form-group">
                            <input type="text" v-model="formData.adress" class="form-control" id="address" :placeholder="language.address">
                        </div>
                    </div>

                    <div v-if="hideinputs.hide_ages" class="input-wrapper">
                        <div class="form-group">
                            <select v-model="formData.age" class="form-control" id="age">
                                <option value="" disabled>{{ language.select_age }}</option>
                                <option :selected="formData.age === age.age" v-for="(age, ageIndex) in ages" :key="`age-${ageIndex}`" :value="age.age">{{ age.age }}</option>
                            </select>
                        </div>
                    </div>

                    <div v-if="hideinputs.hide_sex" class="input-wrapper">
                        <div class="form-group">

                            <select v-if="genders.length" v-model="formData.sex" class="form-control" id="gender">
                                <option value="" disabled>{{ language.select_gender }}</option>
                                <option :selected="formData.sex === gender.gender" v-for="(gender, genderIndex) in genders" :key="`gender-${genderIndex}`" :value="gender.gender">{{ gender.gender }}</option>
                            </select>

                            <select v-else v-model="formData.sex" class="form-control" id="gender">
                                <option value="" disabled>{{ language.select_gender }}</option>
                                <option :selected="formData.sex === language.female">{{ language.female }}</option>
                                <option :selected="formData.sex === language.male">{{ language.male }}</option>
                                <option :selected="formData.sex === language.other">{{ language.other }}</option>
                            </select>

                        </div>
                    </div>

                    <div v-if="hideinputs.hide_types" class="input-wrapper">
                        <div class="form-group">
                            <select v-model="formData.type" class="form-control" id="type">
                                <option value="" disabled>{{ language.respond_as }}</option>
                                <option :selected="formData.type === type.type" v-for="(type, typeIndex) in types" :key="`type-${typeIndex}`" :value="type.type">{{ type.type }}</option>
                            </select>
                        </div>
                    </div>
                    <div v-if="hideinputs.hide_counties" class="input-wrapper">
                        <div class="form-group">
                            <select v-model="formData.county" class="form-control" id="county">
                                <option value="" disabled>{{ language.live_in }}</option>
                                <option :selected="formData.county === county.name" v-for="(county, countyIndex) in counties" :key="`county-${countyIndex}`" :value="county.name">{{ county.name }}</option>
                            </select>
                        </div>
                    </div>

                    <div v-if="hideinputs.hide_email" class="input-wrapper">
                        <div class="form-group">
                            <input type="email" v-model="formData.email" class="form-control" id="email" :placeholder="language.email">
                        </div>
                    </div>

                    <div v-if="hideinputs.hide_address" class="input-wrapper">
                        <div  class="form-group">
                            <input type="text" v-model="formData.zip" class="form-control" id="zipcode" :placeholder="language.postcode">
                        </div>
                    </div>

                    <div class="input-wrapper-last">

                        <div v-if="hideinputs.hide_extra_information" class="form-group">
                            <textarea class="form-control" v-model="formData.extrainfo" id="extra-info" placeholder="Övrig information" rows="3"></textarea>
                        </div>

                        <div v-if="newsletter && hideinputs.hide_email" class="form-check">
                            <input type="checkbox" title="nyhetsbrev" v-model="formData.newsletter" class="form-check-input" id="newsletter">
                            <label class="form-check-label" for="newsletter"> {{ language.receive_info.replacePlaceholders({ project : dataStore.project.title }) }}</label>
                        </div>

                        <div class="form-check">
                            <input type="checkbox" v-model="formData.terms" title="Godkännade av användarvillkoren & integritetspolicyn" class="form-check-input" id="terms">
                            <label v-if="hasCustomTerms" class="form-check-label" for="terms" v-html="language.terms_link_custom.replacePlaceholders({ slug: project.slug })"></label>
                            <label v-else class="form-check-label" for="terms" v-html="language.terms_link"></label>
                        </div>

                        <div class="row">

                            <div class="col-12 col-lg-6">
                                <button v-if="allowToSubmitCookie" :title="language.submit" type="submit" :disabled="disableSubmit" class="btn btn-primary">{{ language.submit }}</button>
                            </div>

                            <div class="col-12 col-lg-6">
                                <p class="disclaimer">{{ language.disclaimer }}</p>
                            </div>

                            <div v-if="dataStore.showSpinnerLastPart" class="col-12"><div class="spinner"><div class="lds-ring"><div></div><div></div><div></div><div></div></div></div></div>
                        </div>

                        <div class="row">
                            <div class="col-12">
                                <a class="not-finished" :title="language.go_back" href="#" v-on:click.prevent="notFinished">{{ language.go_back }}</a>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

        </form>

    </div>

</template>

<script>

import axios from "axios";
import dataStore from "../../store";
import VueCookies from 'vue-cookies'
import uuid from "uuid";
import { goToFirst } from './../../functions'

export default {

    inject: [ 'language' ],

    data() {
        return {
            dataStore,
            errors : [],
            disableSubmit : false,
            formData : {
                name : '',
                email : '',
                adress : '',
                zip: '',
                age : '',
                sex : '',
                type: '',
                county : '',
                extrainfo : '',
                terms : false,
                newsletter : false,
                continue_discussion : false
            },

            allowToSubmitCookie: true



        };
    },

    props: {
        hideinputs : Object,
        newsletter : Number,
        counties: Array,
        ages: Array,
        types: Array,
        genders : Array,
        project: Object
    },

    computed : {

        hasCustomTerms: function() {
            return this.hideinputs.hide_terms && this.project.terms.length
        },

    },

    mounted() {

        if( this.project.spam_protection ) {
            this.allowToSubmitCookie = ! VueCookies.get( 'placetoplan-project-' + this.project.id )
        }

        if(VueCookies.get('user')){

            let user = VueCookies.get('user');

            this.formData = Object.assign(this.formData, {
                name : user.name,
                email : user.email,
                adress : user.adress,
                zip: user.zip,
                terms : user.terms
            })

            if(this.project.hide_sex && user.sex !== undefined) {
                this.formData = Object.assign(this.formData, {sex : user.sex})
            }

            if(this.project.hide_ages && user.age !== undefined) {
                this.formData = Object.assign(this.formData, {age : user.age})
            }

            if(this.project.hide_types && user.type !== undefined) {
                this.formData = Object.assign(this.formData, {type: user.type})
            }

            if(this.project.hide_counties && user.county !== undefined) {
                this.formData = Object.assign(this.formData, {county : user.county})
            }

        }
        
    },

    methods: {

        notFinished: function() {
            this.dataStore.showLastPartForm = false
            goToFirst()
        },

        hide: function(e) {

            if( e.srcElement.className.includes('last-part-form') ){

                this.dataStore.showLastPartForm = false;

                if(this.dataStore.addToExistingWindow) {
                    this.dataStore.addToExistingWindow = false
                    this.dataStore.formPopUpReady = false
                    this.dataStore.currentOpinion = [this.dataStore.currentOpinion]
                }

            }
        },

        toggleForm: function() {
            this.dataStore.showLastPartForm = !this.dataStore.showLastPartForm;
            this.dataStore.infoWinOpen = false
            this.dataStore.formPopUpReady = false;

            if(this.dataStore.addToExistingWindow) {
                this.dataStore.addToExistingWindow = false
                this.dataStore.currentOpinion = [this.dataStore.currentOpinion]
            }
        },

        resetLastForm: function() {

            this.formData.email = "";

            this.formData.extrainfo = "";

            this.formData.terms = false;

            this.formData.continue_discussion = false

            if(this.project.hide_sex) {
                this.formData.sex = "";
            }

            if(this.project.hide_ages) {
                this.formData.age = "";
            }

            if(this.project.hide_types) {
                this.formData.type = "";
            }

            if(this.project.hide_counties) {
                this.formData.county = "";
            }

        },

        submitForm: async function(event) {

            this.errors = [];

            if (this.hideinputs.hide_ages && !this.formData.age) {
                this.errors.push( this.language.error_select_age );
            }

            if (this.hideinputs.hide_sex && !this.formData.sex) {
                this.errors.push( this.language.error_select_sex );
            }

            if (this.hideinputs.hide_types && !this.formData.type) {
                this.errors.push( this.language.error_select_type );
            }

            if (this.hideinputs.hide_counties && !this.formData.county) {
                this.errors.push( this.language.error_select_county );
            }

            if (! this.formData.terms) {
                this.errors.push( this.language.error_select_terms );
            }

            if(this.hideinputs.hide_email && this.newsletter){
                if(this.formData.newsletter && !this.formData.email.length ) {
                    this.errors.push( this.language.error_select_email );
                }
            }

            if(!this.errors.length){

                try {

                    this.dataStore.deepLink = await this.createUniqueGuid();

                    this.dataStore.showSpinnerLastPart = true;

                    let answers = this.dataStore.collectedAnswers.filter(a => a.addOnExisting);

                    answers = answers.length > 0 ? answers : this.dataStore.collectedAnswers;

                    if(answers.length){

                        let postObjectArray = answers
                        .filter(item => item.created)
                        .map((item) => {

                            return {
                                item_id: item.item_id,
                                lat: item.lat,
                                lng: item.lng,
                                value : item.values,
                                value_type : item.value_type,
                                image : item.image,
                                comment : item.comment,
                                question_id : item.question.id,
                                deep_link : this.dataStore.deepLink,
                                project_id : this.dataStore.project.id
                            }

                        });

                        if(!this.disableSubmit) {

                            this.disableSubmit = true;

                            axios.post(
                                `/api/save-answer`, {
                                    values : postObjectArray,
                                    form_data : this.formData
                                }
                            )
                            .then(response => {

                                if(!VueCookies.get('user')){
                                    this.resetLastForm();
                                }

                                this.resetToolDefault();

                                if( VueCookies.get('slide-number') ) {
                                    VueCookies.set('slide-number', 0)
                                }

                                if( this.project.spam_protection ) {

                                    const expire = '24h' // '2147483647s'
    
                                    VueCookies.set( 'placetoplan-project-' + this.project.id, true, expire )

                                    this.allowToSubmitCookie = false

                                }

                            })
                            .catch(err => {
                                console.error(err);
                            });
                        }

                    } else {

                        if(!VueCookies.get('user')){
                            this.resetLastForm();
                        }

                        this.resetToolDefault();
                    }

                    let userData = {
                        name : this.formData.name,
                        adress : this.formData.adress,
                        email : this.formData.email,
                        adress : this.formData.adress,
                        zip : this.formData.zip,
                        terms : this.formData.terms,
                    }

                    if(this.project.hide_sex) {
                        userData = Object.assign(userData, {sex : this.formData.sex})
                    }

                    if(this.project.hide_ages) {
                        userData = Object.assign(userData, {age : this.formData.age})
                    }

                    if(this.project.hide_types) {
                        userData = Object.assign(userData, {type : this.formData.type})
                    }

                    if(this.project.hide_counties) {
                        userData = Object.assign(userData, {county : this.formData.county})
                    }

                    VueCookies.set('user', userData);

                    goToFirst();

                } catch (error) {
                    console.error(error);
                }
            }
        },

        createUniqueGuid: async function() {

            try {

                let guids = await this.checkGuid()

                if(guids.data) {

                    let guid = uuid.v4().replace(/-/g, "");

                    if(guids.data.includes(guid)) {

                        do {
                            guid = uuid.v4().replace(/-/g, "");
                        }

                        while (guids.data.includes(guid));

                    }

                    return guid;

                } else {
                    return uuid.v4().replace(/-/g, "");
                }

            } catch (error) {
                console.error(error);
            }



        },

        checkGuid: async function() {
            return axios.get(`/api/check-guids/${this.dataStore.project.slug}`)
        },

        resetToolDefault: function () {

            this.resetCheckBoxesAndRadio()

            this.dataStore.showConfirmation = true;
            this.dataStore.formPopUpReady = false;
            this.dataStore.collectedAnswers = [];
            this.dataStore.showLastPartForm = false;
            this.dataStore.showSpinnerLastPart = false;
            this.disableSubmit = false;


        },

        resetCheckBoxesAndRadio: function() {

            const scaleSlides = this.dataStore.collectedAnswers.filter(slide => slide && slide.question && slide.question.type === 'scale')

            if( scaleSlides.length > 0 ) {

                for (const slide of scaleSlides) {

                    // checkboxes - i.e multianswers
                    if( slide.question.allow_multi_answers_scale )  {

                        const checkboxes = document.querySelectorAll(`.item-slide[data-slideid="${slide.item_id}"] input[type="checkbox"]`)

                        checkboxes.forEach(el => {
                            el.checked = false
                        })

                    } 

                }

            } 

        }

    }

};
</script>

